import HTTPClient from './http-client';

const headers = {headers: {'Content-Type': 'application/json'}};

class EstimativaCarga {
  async loadEstimativaCargaPieChart(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.post(`/estimativas_cargas_dbo`, payload, headers);
  }

  async loadEstimativaCargaPieChartAll() {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`/estimativas_cargas_dbo_all`, headers);
  }

  async outorgasEfluentesDBOAll(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.post(`/outorgas_efluentes_dbo_all`, payload, headers);
  }

  async outorgasEfluentesDBO(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.post(`/outorgas_efluentes_dbo`, payload, headers);
  }
}

export default new EstimativaCarga();
